import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueSweetalert2 from 'vue-sweetalert2';
import utilsLib from './mixins/utilsLib';
import store from './store/store';
import VueI18n from 'vue-i18n';
import es from './i18n/es';
import en from './i18n/en';
import moment from 'moment-timezone';
import VueMoment from 'vue-moment';

Vue.use(VueSweetalert2);
Vue.use(VueI18n);
Vue.mixin(utilsLib);
Vue.use(VueMoment, {
  moment
});

const i18n = new VueI18n({
  locale: 'es_ES',
  messages: {
    'es_ES': es,
    'en_GB': en
  }
});

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App); }
}).$mount('#app');
